<template>
    <div ref="practicearea">
        <slot :can-click="canClick"></slot>
    </div>
</template>
<script setup>
import { ref, watch, onMounted, onBeforeUnmount } from "vue";

const screenWidth = ref(window.innerWidth);
const practicearea = ref(null);

const canClick = (e) => {
	if(screenWidth.value >= 768){
		e.preventDefault();
		e.target.parentElement.open = true;
		return false;
	}
}

const updateScreenSize = () => {
    screenWidth.value = window.innerWidth;
};

onMounted(() => {
    window.addEventListener("resize", updateScreenSize);
    if(screenWidth.value >= 768){
        practicearea.value.querySelectorAll("details").forEach(details => {
            details.setAttribute("open", "");
        });
    }
});

onBeforeUnmount(() => {
    window.removeEventListener("resize", updateScreenSize);
});

watch(
    screenWidth, (newWidth, oldWidth) => {
        if (newWidth < 768 && oldWidth >= 768) {
            practicearea.value.querySelectorAll("details").forEach(details => {
                details.open = null;
            });
        }
        if (newWidth >= 768 && oldWidth < 768) {
            practicearea.value.querySelectorAll("details").forEach(details => {
                details.setAttribute("open", "");
            });
        }
    }
);
</script>
